import React from "react";

// -------------------------------------------------------------------
// Craftsmanship video source
// -------------------------------------------------------------------
// Replace this URL with real workshop footage anytime (mp4 / webm).
// - Keep it short (5-10s) and looping-friendly.
// - Recommend 1:1 or 4:5 aspect, silent (audio is muted anyway).
// -------------------------------------------------------------------
const CRAFT_VIDEO =
  "https://customer-assets.emergentagent.com/job_gold-shine-pune/artifacts/hv6jpida_gemini_generated_video_C79F672C%202.MP4";

// A still image shown before the video loads, and as a fallback.
const CRAFT_POSTER =
  "https://images.unsplash.com/photo-1601121141461-9d6647bca1ed?auto=format&fit=crop&w=800&q=80";

export default function About() {
  return (
    <section className="about" id="about">
      <div className="wrap about-grid">
        <div className="reveal">
          <span className="eyebrow">Our Story</span>
          <h2>
            Welcome to Alankar Jewellers,
            <br />
            your own trusted jewellers.
          </h2>
          <p>
            It began with a strong aspiration — Mr. Hasmukh Soni, our founder,
            driven by a curious business mind and a simple belief: providing
            for the community mattered more than any single sale. Over 30
            years, that belief has never changed.
          </p>
          <p>
            It was never about earning wealth. It was about building trust —
            connecting with our customers and fellow business enthusiasts to
            nurture a sense of belonging, and to grow together with the
            community that has supported us since the beginning.
          </p>
          <div className="callout">
            We protect you and your loved ones from every mishap in jewellery
            buying. A unique design that outstands the rest — that is what we
            sell: jewellery as unique as you are.
          </div>
        </div>

        <div className="about-visual reveal">
          <div className="craft-frame">
            <video
              className="craft-video"
              src={CRAFT_VIDEO}
              poster={CRAFT_POSTER}
              autoPlay
              loop
              muted
              playsInline
              preload="metadata"
              aria-hidden="true"
            />
            <div className="craft-overlay" />
            <div className="craft-caption">
              <span className="craft-eyebrow">— In our workshop</span>
              <h3>
                Craftsmanship <em>at its finest.</em>
              </h3>
              <p>
                Hand-finished in our Rasta Peth workshop, every piece is
                inspected, polished and hallmarked before it reaches you.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
